import { render, staticRenderFns } from "./Fullpage.vue?vue&type=template&id=35e1dac1&scoped=true"
import script from "./Fullpage.vue?vue&type=script&lang=js"
export * from "./Fullpage.vue?vue&type=script&lang=js"
import style0 from "./Fullpage.vue?vue&type=style&index=0&id=35e1dac1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.3_webpack@5.107.2__lodash@4.18.1_react-dom@16.2.0_rea_78eced9430f46a1a0ce5e8103c760d82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e1dac1",
  null
  
)

export default component.exports